import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Receptionistreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [receptId, setreceptId] = useState("All");
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [recepts, setrecepts] = useState([]);
    const [total, settotal] = useState(0);

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const q = query(collection(db, 'users'), where('role', '==', 'Receptionist'));
                    onSnapshot(q, (querySnapshot) => {
                        setrecepts(querySnapshot.docs.map(doc => ({
                            id: doc.id,
                            data: doc.data()
                        })));
                    });
                    setloadincount(false);
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    const getReport = async () => {
        try {
            if (!fromDate || !toDate || !receptId) {
                Toast.fire({ icon: "error", title: 'Please select From Date & To Date & Receptionist' });
                return;
            }

            setloading(false);
            setbookingData([]);
            setpaymodes([]);
            setpayhistory([]);

            const today = new Date(fromDate);
            today.setHours(0, 0, 0, 0);

            const tomorrow = new Date(toDate);
            tomorrow.setDate(tomorrow.getDate() + 1);

            // Base queries
            let bookingsQuery, payhistoryQuery;
            if (receptId === 'All') {
                bookingsQuery = query(
                    collection(db, 'bookings'),
                    where('createdAt', '>=', Timestamp.fromDate(today)),
                    where('createdAt', '<', Timestamp.fromDate(tomorrow))
                );
                payhistoryQuery = query(
                    collection(db, 'payhistory'),
                    where('createdAt', '>=', Timestamp.fromDate(today)),
                    where('createdAt', '<', Timestamp.fromDate(tomorrow))
                );
            } else {
                bookingsQuery = query(
                    collection(db, 'bookings'),
                    where('uid', '==', receptId),
                    where('createdAt', '>=', Timestamp.fromDate(today)),
                    where('createdAt', '<', Timestamp.fromDate(tomorrow))
                );
                payhistoryQuery = query(
                    collection(db, 'payhistory'),
                    where('uid', '==', receptId),
                    where('createdAt', '>=', Timestamp.fromDate(today)),
                    where('createdAt', '<', Timestamp.fromDate(tomorrow))
                );
            }

            // Fetch all payment modes once
            const paymentModesPromise = getDocs(collection(db, 'paymentmodes'));

            // Execute all queries in parallel
            const [bookingsSnap, payhistorySnap, paymentModesSnap] = await Promise.all([
                getDocs(bookingsQuery),
                getDocs(payhistoryQuery),
                paymentModesPromise,
            ]);

            // Fetch user data for unique UIDs
            const uids = [...new Set([...bookingsSnap.docs.map(doc => doc.data().uid), ...payhistorySnap.docs.map(doc => doc.data().uid)])];
            const userPromises = uids.map(uid => getDoc(doc(db, 'users', uid)));
            const usersSnap = await Promise.all(userPromises);
            const usersData = {};
            usersSnap.forEach(userSnap => {
                if (userSnap.exists()) {
                    usersData[userSnap.id] = userSnap.data().username;
                }
            });

            // Process bookings
            const bookingsData = bookingsSnap.docs.map(doc => {
                const data = doc.data();
                const username = usersData[data.uid] || 'Unknown User';
                return {
                    id: doc.id,
                    data: {
                        ...data,
                        username,
                    },
                };
            });
            setbookingData(bookingsData);

            // Calculate total bookings amount
            const totalBookingsAmount = bookingsSnap.docs.reduce((sum, doc) => {
                return sum + parseFloat((doc.data().totalamount || 0).toFixed(0));
            }, 0);
            settotal(totalBookingsAmount.toFixed(0));

            // Process payment history with parallel fetching of payment modes
            const paymentModes = {};
            paymentModesSnap.docs.forEach(doc => {
                paymentModes[doc.id] = doc.data().paymode;
            });

            const combinedPayHistory = payhistorySnap.docs.map(doc => {
                const data = doc.data();
                const paymode1 = paymentModes[data.paymode1] || "";
                const paymode2 = paymentModes[data.paymode2] || "";
                const username = usersData[data.uid] || 'Unknown User';

                const date = data.createdAt.toDate();
                const formattedDate = date.toISOString().replace('T', ' ').slice(0, 19);

                return {
                    id: doc.id,
                    data,
                    username,
                    paymode1,
                    paymode2,
                    createdat: formattedDate,
                };
            });
            setpayhistory(combinedPayHistory);

            // Calculate total payments by paymode1 and paymode2
            const paymentModesData = paymentModesSnap.docs.map(doc => {
                const modeId = doc.id;
                const paymode = doc.data().paymode;

                const total1 = payhistorySnap.docs.reduce(
                    (sum, payDoc) => sum + (payDoc.data().paymode1 === modeId ? parseFloat((payDoc.data().amount1 || 0).toFixed(0)) : 0),
                    0
                );
                const total2 = payhistorySnap.docs.reduce(
                    (sum, payDoc) => sum + (payDoc.data().paymode2 === modeId ? parseFloat((payDoc.data().amount2 || 0).toFixed(0)) : 0),
                    0
                );

                return {
                    id: modeId,
                    paymode,
                    totalamount: (total1 + total2).toFixed(0),
                };
            });

            setpaymodes(paymentModesData);

            setloading(true);
        } catch (error) {
            console.error("Error fetching data:", error);
            setloading(true);
        }
    };



    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| Receptionist Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-3'>
                                                <label>Select Receptionist</label>
                                                <select value={receptId} onChange={(e) => setreceptId(e.target.value)} className='form-control'>
                                                    <option value="All">All</option>
                                                    {
                                                        recepts.map((item, index) =>
                                                            <option value={item.data.uid}>{item.data.username}</option>
                                                        )
                                                    }
                                                </select>
                                            </div>
                                            <div className='col-sm-3'>
                                                <label>From Date</label>
                                                <input type='date' value={fromDate} onChange={handleFromDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <label>To Date</label>
                                                <input type='date' value={toDate} onChange={handleToDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    loading &&
                                    <>
                                        <div className="card card-primary card-outline" ref={printRef}>
                                            <div className="card-body">
                                                <div className="row invoice-info">
                                                    <div className="col-sm-12 invoice-col text-center">
                                                        <address>
                                                            <h4>Dasara Executive</h4>
                                                            Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                            Phone: +91 9975294940 |
                                                            Email:  dasaraexecutive@gmail.com<br />
                                                            Website:  www.dasaraexecutive.com
                                                        </address>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <table className='customers2 '>
                                                        <tr>
                                                            <th style={{ textAlign: "center" }}>From Date : {moment(fromDate).format('DD/MM/YYYY')}  </th>
                                                            <th style={{ textAlign: "center" }}><h5 style={{ textTransform: "uppercase" }}>{username}  REPORT </h5></th>
                                                            <th style={{ textAlign: "center" }}>To Date : {moment(toDate).format('DD/MM/YYYY')}</th>
                                                        </tr>
                                                    </table>
                                                    <table className="customers2">
                                                        <thead>
                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Customer Name </th>
                                                                <th>Mobile </th>
                                                                <th>Checkin Date </th>
                                                                <th>Checkout Date </th>
                                                                <th>Rooms </th>
                                                                <th>Adults </th>
                                                                <th style={{ textAlign: "right" }}>Total</th>
                                                                <th style={{ textAlign: "right" }}>Paid</th>
                                                                <th style={{ textAlign: "right" }}>Remaining</th>
                                                                <th style={{ textAlign: "right" }}>Username</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                bookingData.map((item, num = 1) =>
                                                                    <tr key={num + 1}>
                                                                        <td width="80">{num + 1}</td>
                                                                        <td>{item.data.customers.custname}</td>
                                                                        <td>{item.data.customers.mobile} </td>
                                                                        <td>{moment(item.data.checkindate).format('DD/MM/YYYY')}</td>
                                                                        <td>{moment(item.data.checkoutdate).format('DD/MM/YYYY')}</td>
                                                                        <td>
                                                                            <div className='row'>
                                                                                {item.data.rooms.map((item1, index) =>
                                                                                    <span key={index}>{item1.roomname} &nbsp;  </span>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        <td>{item.data.adults} Persons</td>
                                                                        <td style={{ textAlign: "right" }}>{item.data.totalamount.toFixed(0)}</td>
                                                                        <td style={{ textAlign: "right" }}>{item.data.advance.toFixed(0)}</td>
                                                                        <td style={{ textAlign: "right" }}>{item.data.remaining.toFixed(0)}</td>
                                                                        <td style={{ textAlign: "right" }}>{item.data.username}</td>

                                                                    </tr>
                                                                )}
                                                        </tbody>
                                                    </table>
                                                    <table className='customers2'>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E0FCFE" }}> <h6> Total Booking Amount :  Rs. {total} /- </h6></th>
                                                            </tr>
                                                        </thead>
                                                    </table>
                                                    {/* <table className="customers2">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E0FCFE" }} colSpan={10}>Collection Reports</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Paymode 1</th>
                                                                <th>Amount 1</th>
                                                                <th>Paytime 1</th>
                                                                <th>Paymode 2</th>
                                                                <th>Amount 2</th>
                                                                <th>Paytime 2</th>
                                                                <th>Datetime</th>
                                                                <th>Note</th>
                                                                <th>Username</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                payhistory.map((item, index) =>
                                                                    <tr key={index}>
                                                                        <td>{item.paymode1}</td>
                                                                        <td>{item.data.amount1}</td>
                                                                        <td>{item.data.paytime1}</td>
                                                                        <td>{item.paymode2}</td>
                                                                        <td>{item.data.amount2}</td>
                                                                        <td>{item.data.paytime2}</td>
                                                                        <td>{item.createdat}</td>
                                                                        <td>{item.data.note}</td>
                                                                        <td>{item.data.username}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </table> */}
                                                    <table className='customers2'>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E0FCFE" }} colSpan={paymodes.length + 1}>Paymode Wise Collection</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Paymodes</th>
                                                                {
                                                                    paymodes.map((item, index) =>
                                                                        <th key={index}>{item.paymode}</th>
                                                                    )
                                                                }
                                                            </tr>
                                                            <tr>
                                                                <th>Amount</th>
                                                                {
                                                                    paymodes.map((item, index) =>
                                                                        <td key={index}>{item.totalamount}</td>
                                                                    )
                                                                }
                                                            </tr>
                                                        </thead>
                                                    </table><br />
                                                    <table className='customers2'>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#E0FCFE" }}> <h6> Total Collection of {username} :  Rs. {total} /- </h6></th>
                                                            </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                        <center>
                                            <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                        </center>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </section >




            </div>



        </div >

    )
}

export default Receptionistreport
